var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-lg p-0 mx-4",staticStyle:{"background":"none"}},[_c('commentMilestone'),_c('targetMilestone'),_c('improvementMilestone')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }